import React from "react";
import styled from "styled-components";
import * as Router from "next/router";

import { colours } from "@/utils";
import { getEmployeeTestimonials } from "@/components/hooks/query/useContentQuery";
import RxLoadingScreen from "@/components/ui/display/RxLoadingScreen";
import RxPageLayout from "@/components/ui/display/RxPageLayout";
import RxStickyButtonStrip from "@/components/ui/inputs/RxStickyButtonStrip";
import CareersHeroContent from "../../components/careers/CareersHeroContent";
import CareersJoinContent from "@/components/careers/CareersJoinContent";
import StatContent from "@/components/marketing/StatContent";
import CareersTestimonialContent from "@/components/careers/CareersTestimonialContent";
import CareersSuperchargeContent from "@/components/careers/CareersSuperchargeContent";
import CtaStrip from "@/components/marketing/CtaStrip";

export default function Careers() {
  const router = Router.useRouter();
  const employeeTestimonials = getEmployeeTestimonials();
  const testimonialsLoading = employeeTestimonials.isLoading;

  if (testimonialsLoading) return <RxLoadingScreen />;

  return (
    <RxPageLayout>
      <RxStickyButtonStrip
        backgroundColour={colours.teal}
        buttonText="See open roles"
        name="see_open_roles"
        onClick={() => router.push("https://harri.com/allbright-careers")}
      />
      <CareersHeroContent />
      <CareersJoinContent />
      {!!employeeTestimonials.data &&
        employeeTestimonials.data.map((testimonial, index) => (
          <CareersTestimonialContent
            {...testimonial}
            key={testimonial.employeeName}
            videoOnRight={index % 2 !== 0}
          />
        ))}
      <StatContent
        background={colours.teal}
        copy={
          <>
            <S.BoldWrap>
              AllBright is a global collective of change-makers{" "}
            </S.BoldWrap>
            <br />
            powered by ambitious women, committed to <br />
            <S.BoldWrap>creating an equitable world for all.</S.BoldWrap>
            <br />
            <br />
            Our vision is to create a world of{" "}
            <S.BoldWrap>unlimited possibilities </S.BoldWrap>for ambitious
            women.
          </>
        }
        copyColour={colours.shell}
      />
      <CareersSuperchargeContent />
      <CtaStrip
        backgroundColour={colours.teal}
        copy="Find the right job for you"
        linkText="View jobs"
        linkUrl="https://harri.com/allbright-careers"
        textColour={colours.shell}
        target="_blank"
      />
    </RxPageLayout>
  );
}

const S = () => {};

S.BoldWrap = styled.span`
  font-weight: 700;
`;
